<template lang="html">
  <div id="doctor-add-review" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9">
      <div class="row" v-if="pet && owner">
        <div class="col-md-12">
          <div class="row  owner-profile">
            <div class="col-md-12 owner-header">
              <div class="col-md-6 text-center">
                <div class="row">
                  <div class="col-md-4">
                    <div v-if="this.previewImage != null">
                      <img v-bind:src="this.previewImage" class="uploading-image img-responsive img-circle" v-model="owner.avatar"/>
                    </div>
                    <div v-else>
                      <img class="uploading-image img-responsive img-circle" src="../../assets/img/user-home-icon-default.svg" alt="Default Image">
                    </div>
                  </div>
                  <div class="col-md-8 owner-name">
                      <span>{{translation.profile.owner}}: </span>{{owner.firstName + ' ' + owner.lastName}}
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-right show-hide-owner">
                <button class="btn" @click="toggleOwnerFn">
                  <span  v-if="toggleOwner">{{translation.petProfile.hide}}</span>
                  <span v-else>{{translation.petProfile.show}}</span>
                </button>
              </div>
            </div>
            <div class="col-md-12 text-left owner-info" v-if="toggleOwner">
              <div class="row">
                <div class="col-md-4">
                  <p class="user-header-text">{{translation.registration.email}}:</p>
                  <p class="user-text"><span v-if="owner.email">{{owner.email}}</span></p>
                </div>
                <div class="col-md-4">
                  <p class="user-header-text">{{translation.registration.phoneNumber}}:</p>
                  <p class="user-text"><span v-if="owner.phoneNumber">{{owner.phoneNumber}}</span></p>
                </div>
                <div class="col-md-4">
                  <p class="user-header-text" v-if="owner.country">{{translation.updateProfile.country}}:</p>
                  <p class="user-text" v-if="owner.country && owner.country != 'null'">{{owner.country}}</p>
                </div>
              </div>
              <div class="row user-adress">
                <div class="col-md-4">
                  <p class="user-header-text" v-if="owner.city">{{translation.updateProfile.city}}:</p>
                  <p class="user-text" v-if="owner.city && owner.city != 'null'">{{owner.city}}</p>
                </div>
                <div class="col-md-4">
                  <p class="user-header-text" v-if="owner.country">{{translation.updateProfile.neighborhood}}:</p>
                  <p class="user-text" v-if="owner.neighborhood && owner.neighborhood != 'null'">{{owner.neighborhood}}</p>
                </div>
                <div class="col-md-4"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row header-pet">
            <div class="col-md-6">
              <div class="pet-image">
                <div class="row">
                  <div class="col-md-4">
                    <img v-if="pet.petAvatar" class="img-responsive img-circle" v-bind:src="pet.petAvatar">
                    <img v-else class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Pet Image">
                  </div>
                  <div class="col-md-4 owner-name">
                    {{translation.pets.pet + pet.petName}}
                  </div>
                  <div class="col-md-4 owner-name">
                    <p id="indeNumber">{{translation.petProfile.identNumber + ': ' + pet.passportId}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-right show-hide-owner">
              <button class="btn" @click="togglePetFn">
                <span  v-if="togglePet">{{translation.petProfile.hide}}</span>
                <span v-else>{{translation.petProfile.show}}</span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 pet-profile text-center"  v-if="togglePet">
                <div class="pet-info text-left">
                  <div class="col-md-12">
                    <div class="row text-left">
                      <div class="col-md-12 text-left">
                        <h3>{{translation.pets.description}}</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.name}}:</p>
                        <p class="pet-text"><span v-if="pet.petName">{{pet.petName}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.species}}:</p>
                        <p class="pet-text"><span v-if="pet.petSpecies">{{pet.petSpecies}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.breed}}:</p>
                        <p class="pet-text"><span v-if="pet.petBreed">{{pet.petBreed}}</span></p>
                      </div>
                    </div>
                    <div class="row pet-border">
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.sex}}:</p>
                        <p class="pet-text"><span v-if="pet.petSex">{{pet.petSex}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.birthDate}}:</p>
                        <p class="pet-text"><span v-if="pet.petBirthDate">{{pet.petBirthDate}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.coat}}:</p>
                        <p class="pet-text"><span v-if="pet.petCoat">{{pet.petCoat}}</span></p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pets-identification pet-border" >
                    <div class="row text-left">
                      <div class="col-md-12 text-left">
                        <h3>{{translation.pets.identification}}</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.microchip}}:</p>
                        <p class="pet-text"><span v-if="pet.microchip">{{pet.microchip}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.dateMicrochipping}}:</p>
                        <p class="pet-text"><span v-if="pet.dateMicrochipping">{{pet.dateMicrochipping}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.microchipping}}:</p>
                        <p class="pet-text"><span v-if="pet.microchipping">{{pet.microchipping}}</span></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.tattooNumber}}:</p>
                        <p class="pet-text"><span v-if="pet.tattooNumber">{{pet.tattooNumber}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.tattooDate}}:</p>
                        <p class="pet-text"><span v-if="pet.tattooDate">{{pet.tattooDate}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <div v-if="passport.approved">
                          <p class="pet-header-text">{{translation.pets.appRovedPassport}} </p>
                          <p class="pet-text">{{translation.petReview.addByDoctor + passport.doctorFirstName + ' ' + passport.doctorLastName}}</p>
                        </div>
                        <div v-else>
                          {{translation.pets.disabledInformation}}
                          <button class="btn btn-warning submit-button" @click="approvPassport" :disabled='disableButton'>{{translation.button.approvе}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pets-pedigree text-left">
                    <div class="row">
                      <div class="col-md-12">
                        <h3>{{translation.pets.pedigree}}</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.kennel}}:</p>
                        <p class="pet-text"><span v-if="pet.kennel">{{pet.kennel}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.mother}}:</p>
                        <p class="pet-text"><span v-if="pet.mother">{{pet.mother}}</span></p>
                      </div>
                      <div class="col-md-4">
                        <p class="pet-header-text">{{translation.pets.father}}:</p>
                        <p class="pet-text"><span v-if="pet.father">{{pet.father}}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          </div>
      </div>
      <div class="row">
        <div class="col-sm-12" v-show="showReviews && !serverMessage">
          <PetReviewModal :petId='petId'/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PetReviewModal from '../../components/review/addReview.vue';
  export default {
    name: 'DoctorHome',
    components: {
      PetReviewModal
    },
    data(){
      return {
        translation: null,
        searchPet: {
          identification: this.$route.params.passportId,
          microchip: ''
        },
        showInfoForSeraching: true,
        serverMessage: false,
        doctorAutorization: false,
        loader: false,
        passport:[],
        pet:'',
        owner: '',
        errors: [],
        doctor: '',
        showReviews: false,
        disableButton: true,
        noResult : false,
        togglePet: false,
        showPetInformation: false,
        ownerInformation: false,
        showOwnerInformation: false,
        toggleOwner: false,
        petId: this.$route.params.petId,
        previewImage:null
      }
    },
    created(){
      this.$bus.$on('language', () => {
        this.translation = window.message;
      });
      this.translation = window.message;
      window.pageHeader = this.translation.petProfile.profile;
      this.$bus.$on('approvedPassport', () => {
        this.getPassport();
      });
      this.searchPetForm();
      this.getDoctor();

   },
   methods: {
     validate: function () {
       this.errors = [];
       if (!this.searchPet.identification && !this.searchPet.microchip) {
         this.errors.push(
           this.translation.registration.field + ' "' +
           this.translation.pets.identification + '" ' +
           this.translation.doctor.or + ' "' +
           this.translation.pets.microchip + '" ' +
           this.translation.registration.required
         );
       }
       if (!this.errors.length) {
         return true;
       }
     },
     searchPetForm: function (){
       if (this.validate()) {
         this.loader = true;
         var formData = this.toFormData(this.searchPet);
         var self = this;
         axios.post('search-pet-add-review', formData)
         .then(function(response){
           self.loader = false;
           self.pet = "";
           self.owner = "";
           if (response.data.result.noResult) {
             self.noResult = false;
             self.noResult = response.data.result.noResult;
             self.showPetInformation = false;
             self.showOwnerInformation  = false;
             self.showReviews = false;
             self.showInfoForSeraching = true;
           }else if (response.data.result.serverMessage == 'notPayedFee') {
             self.serverMessage = true;
             self.showInfoForSeraching = false;
             self.doctorAutorization = false;
           }else if (response.data.result.serverMessage == 'doctorAutorization') {
             self.doctorAutorization = true;
             self.serverMessage = false;
             self.showInfoForSeraching = false;
           }else {
             self.noResult = false;
             self.showReviews = true;
             self.showInfoForSeraching = false;
             self.serverMessage = false;
             self.doctorAutorization = false;
             self.petId = response.data.result.petId;
             self.pet = response.data.result.pet;
             self.owner = response.data.result.owner;
             localStorage.setItem('petName', self.pet.petName );
             if (response.data.result.petReview) {
               self.pet.petReview = '../../..' + response.data.result.petReview;
             }
             if (self.owner.avatar) {
               self.previewImage = self.owner.avatar;
             }
             if (response.data.result.pet.microchip !='') {
               self.disableButton = false;
             }
             self.petId = response.data.result.pet.petNumber;
             self.showPetInformation = true;
             self.showOwnerInformation  = true;
             self.getPassport();
             self.$bus.$emit('getIds', true);
           }
           self.searchPet = { identification: "", microchip: ""}
         })
         .catch(err => err)
       }
     },
     getPassport: function(){
       var formData = this.toFormData({petId: this.pet.petNumber});
       var self = this;
       axios.post('get-pet-passport', formData)
       .then(function(response){
         self.passport = response.data.result;
       })
       .catch(err => err)
     },
     getDoctor: function(){
       this.loader = true;
       var self = this;
       axios.get('get-doctor')
       .then(function (response){
           self.loader = false;
           self.doctor = response.data.result;
       })
       .catch(err => console.error(err))
     },
     approvPassport: function(){
       var formData = this.toFormData({
         passportId: this.pet.petNumber,
         approved: 1,
         name: this.doctor.name,
         doctorLastName: this.doctor.doctorLastName
       });
       var self = this;
       axios.post('approve-pet-passport', formData)
       .then(function(response){
         self.$bus.$emit('approvedPassport', true);
       })
       .catch(err => err)

     },
     toFormData: function (obj){
       var form_data = new FormData();
       for (var key in obj) {
         form_data.append(key,obj[key]);
       }
       return form_data;
     },
     togglePetFn: function(){
       this.togglePet = !this.togglePet;
     },
     toggleOwnerFn: function(){
       this.toggleOwner = !this.toggleOwner;
     }
   }
  }

</script>

<style>
#doctor-add-review .col-lg-9{
  padding-top: 9em;
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  background-position: center;
  background-size: cover;
  padding-bottom: 3em;
  min-height: 100vh;
}
.owner-profile{
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.pet-profile{
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
  min-height: 36em;
}
.owner-header,.pet-border{
  border-bottom: 1px solid #EEEEEE;
  padding: 1em;
}
.owner-header img{
  width: 5em;
  height: 5em;
  border: 2px solid #3057B0;
}
.header-pet{
  padding: 1em;
  background: #3057B0;
  color: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
}
.header-pet img{
  width: 5em;
  height: 5em;
  border: 2px solid #eee;
}
.owner-info{
  padding: 1em;
}
.owner-name,
.show-hide-owner{
  margin-top: 2em;
}
.show-hide-owner button {
  background: transparent;
  border: none;
  text-decoration: underline;
}
.header-pet .show-hide-owner button:hover,
.header-pet .show-hide-owner button:focus,
.header-pet .show-hide-owner button:active{
  color: #fff;
}
.user-header-text,.pet-header-text{
  margin-top: 2em;
  color: #707070;
}
.user-text,.pet-text{
  color: #3057B0;
  font-weight: bold;
}
#doctor-add-review .pet-review .pet-review-container{
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
  margin-top: 5em;
}
#doctor-add-review input{
  box-shadow: none;
}
#doctor-add-review h3{
  margin: 1em;
  color: #3057B0;
  padding-top: .3em;
}
#doctor-add-review .search-pet {
  padding: 3em;
  background: #84AE53;
  margin-bottom: 3em;
}
#doctor-add-review .search-pet  input[type=text]:focus + label
 {
    display: block;
    position: absolute;
    bottom: 3.5em;
    color: #707070!important;
    font-size: 1em;
    opacity: 1;
}
#doctor-add-review .search-pet
input[type=text]:focus + label
 {
    display: block;
    position: absolute;
    bottom: 2em;
    color: #707070!important;
    font-size: 1em;
    opacity: 1;
}
.search-vet-button button{
  background: #fff;
  border: none;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 5em;
  color: #3057B0;
  font-weight: bold;
}
.form-group{
  position: relative;
  margin-top: 2em;
}
 .search-pet  input[type=text],
 .search-pet  input[type=password],
 .search-pet  input[type=email]
{
 color: #fff!important;
 background: none!important;
 border: none!important;
 border-radius: 0!important;
 outline: none!important;
 border-bottom: 2px solid #fff!important;
 width: 100%;
 outline: none!important;
 box-shadow: none;
}
 label {
 display: none;
}
 .search-pet  input[type=text]:focus,
 .search-pet  input[type=password]:focus,
 .search-pet  input[type=email]:focus
{
 border-bottom: 2px solid #3057B0!important;
 outline:0px !important;
 -webkit-appearance:none;
 box-shadow: none !important;
}
 .search-pet input[type=text]:focus + label
{
  display: block;
  position: absolute;
  bottom: 2em;
  color: #fff!important;
  font-size: 1em;
  opacity: 1;
}
.search-pet ::placeholder {
  color: #fff!important;
  opacity: 1;
}
.search-pet :-ms-input-placeholder {
  color: #fff!important;
  opacity: 1;
}
.search-pet ::-ms-input-placeholder {
  color: #fff!important;
  opacity: 1;
}
 .search-pet input[type=text]:focus::-webkit-input-placeholder,
 .search-pet input[type=password]:focus::-webkit-input-placeholder,
 .search-pet input[type=email]:focus::-webkit-input-placeholder
{
 color:transparent!important;
}
 input[type=text]:focus::-moz-placeholder
 input[type=password]:focus::-moz-placeholder
 input[type=email]:focus::-moz-placeholder {
 color:transparent!important;
}
 input[type=text]:focus::-moz-placeholder
 input[type=password]:focus::-moz-placeholder
 input[type=email]:focus::-moz-placeholder {
  color:transparent!important;
}
 input[type=text]:focus::-ms-input-placeholder
 input[type=password]:focus::-ms-input-placeholder
 input[type=email]:focus::-ms-input-placeholder {
 color:transparent!important;
}
</style>
